<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-like`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.675 2.493l.365.17c2.432 1.173 5.964 3.54 5.964 7.34 0 1.506-.67 3.504-2.007 5.994h7.578c5.968 0 7.339 5.268 5.968 9.215l-5.968 15.71c-.504 1.827-2.183 3.095-4.1 3.095H9.985v-28.02h4.094l8.9-12.661c.562-.894 2.08-1.58 3.696-.843zM7 16v28H3V16h4zm18.677-9.547l-9.52 13.544h-2.172v20.02h20.49c.124 0 .22-.073.245-.16l.05-.18 6.011-15.826c.79-2.328.002-3.854-2.206-3.854H24.307l3.167-5.893c1.053-1.96 1.53-3.385 1.53-4.101 0-1.16-1.244-2.474-3.327-3.55z"/></svg>
</template>
<script>

export default {
  name: 'IconLike',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
